import type { FaireProductEntity } from "../../entity_types/product";

export const p_m47ktwazvd: FaireProductEntity = {
  token: "p_m47ktwazvd",
  type: "product",
  name: "WOOO Pig! Wooo Pig Earrings Cute Arkansas Gift Razorbacks",
  brandToken: "b_af92w55rjq",
  brandName: "Steele Sloan Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/7471f78300f335d33a5d7975744ca93be54de13eb0eac54f219079d94e57976d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c731d623647518f42bad24c703db6329a8f638bc4804b21cc9e2ac8a6e56e9e4.jpeg",
    "https://cdn.faire.com/fastly/be9e2495cba8fdc334c17fc17fbfca38cf10be0d630652a5b8673a653947328a.jpeg",
    "https://cdn.faire.com/fastly/9313ec2e2eb8f71143196a63c6ff7276b9b0106f42204e3f46b93ce683f0bbca.jpeg",
    "https://cdn.faire.com/fastly/27eafceafe5022cebe550d071db5b17dfbaff6e5bd86078189bf32395e2cf181.jpeg",
    "https://cdn.faire.com/fastly/2eb4f1d08971029d4078bce9bdd57e710c6fa6ef8cdbe2a428bf2cdcf26c71c3.jpeg",
    "https://cdn.faire.com/fastly/23f318dd9c4873b7a7ba6b350419178c8af1252fa886e33b4d41522577e6cf7a.jpeg",
  ],
  priceDollars: 8,
  description:
    'WOOO Pig! Wooo Pig Earrings Cute Arkansas Game Day Gold Stud Earrings Razorback Fans Hypoallergenic Arkansas Gift Arkansas Graduation Gift  Officially Licensed\n\nWOOO Pig! Adorable Game Day Wooo Pig earrings to support University of Arkansas Razorback Fans!  These gold stud earrings are made of hypoallergenic surgical grade stainless steel - great for sensitive ears and non-tarnish -  Wooo measures approximately 3/4 inch and Pigs 1/2 inch - Let\'s go Arkansas Razorbacks!  \n\nThis is an Officially Licensed Product\nMaterial: Hypoallergenic Stainless Steel\nColor: Gold \nSize: approximately 3/4 inch "Wooo" and 1/2 inch "Pigs"\n all Arkansas Fans will love!\n#gohogs #wooopig #cutegiftArkansas #arkansasgraduationgift #gradgift #arkansasgameday #gamedayearrings #razorbacks #goingtoArkansasgift',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:04.851Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
